const ERROR_MESSAGES = {
  generic: 'Bitte überprüfe deine Eingabe.',
};
export function validateForm(schema, state) {
  let data_fields = Object.keys(schema);
  let errors = {};

  data_fields.forEach((field) => {
    if (state.has(field)) {
      errors[field] = validateField(schema, field, state);
    }
  });
  return errors;
}

export function validateField(schema, field, state) {
  let field_value = state.get(field);
  let field_rules = schema[field];
  let errors = [];

  if (field_rules.required && !field_value) {
    if (
      typeof field_rules.messages !== 'undefined' &&
      typeof field_rules.messages.required !== 'undefined'
    ) {
      errors.push(field_rules.messages.required);
    } else {
      errors.push('Pflichtfeld');
    }
    return errors;
  }
  if (field_rules.minlength && field_value.length < field_rules.minlength) {
    errors.push('Mindestens ' + field_rules.minlength + ' Zeichen');
  }
  if (field_rules.maxlength && field_value.length > field_rules.maxlength) {
    errors.push('Maximal ' + field_rules.maxlength + ' Zeichen');
  }
  if (field_rules.minvalue && field_value < field_rules.minvalue) {
    if (field_rules.messages?.minvalue) {
      errors.push(field_rules.messages.minvalue);
    } else {
      errors.push(ERROR_MESSAGES.generic);
    }
  }
  if (field_rules.numeric && field_value !== '') {
    let str_field_value = field_value + '';
    let matches = str_field_value.match(/^[0-9]*$/g);
    if (matches === null || matches.length !== 1) {
      errors.push('Muss eine Nummer sein');
    }
  }
  if (field_rules.length && field_value.length !== field_rules.length) {
    errors.push(`Bitte gib ${field_rules.length} Ziffern ein`);
  }
  if (field_rules.obtainedFromPostCode && state.get('city') === ' ') {
    errors.push('Bitte gib eine gültige Postleitzahl ein.');
  }
  return errors;
}

export function stringifyFormData(data) {
  return JSON.stringify(Object.fromEntries(data));
}
